import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import TextInput from "./FormFields/TextInput";

import { Link } from "react-router-dom";

function Login({ homeRef, handleScroll }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };

  const schema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Provide valid email address"),
    password: Yup.string().required(`Password must not be empty`),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    setIsSubmitting(true);
    setTimeout(() => {
      window.location.href = "/admin";
    }, 1000);
  };

  return (
    <>
      <header
        ref={homeRef}
        onScroll={handleScroll}
        className="position-relative w-100 pt-80 height-74 pb-5"
      >
        <div className="position-absolute start-0 top-0 w-100 height-74 linear-gradient-primary-bg z-index-1"></div>
      </header>
      <main className="container">
        <div className="max-width-720 mx-auto p-2 px-sm-3 py-sm-3 shadow-sm mb-5">
          {isSubmitting ? (
            <div
              style={{ minHeight: "500px" }}
              className="d-flex align-items-center justify-content-center"
            >
              <div
                className="spinner-grow"
                style={{ width: "3rem", height: "3rem" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <h1 className="fs-4 mb-5">Login</h1>
              <Formik
                initialValues={initialValues}
                validationSchema={schema}
                onSubmit={handleSubmit}
              >
                <Form>
                  <div className="row">
                    <TextInput
                      label="Email"
                      name="email"
                      type="text"
                      placeholder="Email"
                    />
                    <TextInput
                      label="Password"
                      name="password"
                      type="password"
                      placeholder="Password"
                    />

                    <div className="col-12">
                      <div className="d-grid my-3">
                        <button
                          className="btn btn-lg btn-primary"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </Formik>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <Link className="text-dark" to="/forgot-password">Forgot password?</Link>
                  </div>
                  <div>
                    <Link className="text-dark" to="/sign-up">Create new account</Link>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
}

export default Login;
